import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b40a59b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LoginIndex" }
const _hoisted_2 = { class: "bg" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "loginBox" }
const _hoisted_5 = { class: "loginRight" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loginTitle" }, [
  /*#__PURE__*/_createTextVNode(" 欢迎登录"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 养殖险验标系统 ")
], -1))
const _hoisted_7 = { class: "formBox" }
const _hoisted_8 = {
  key: 0,
  class: "pwd-strength-meter"
}
const _hoisted_9 = { class: "pwd-strength-bars" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "password-tip" }, " 温馨提示：密码需要8-18位，且包含至少一个字母+至少一个数字，@$!%*#?&中至少一个特殊字符。 ", -1))
const _hoisted_11 = { class: "dialog-footer" }

import { FormInstance, FormRules, ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { isMatchPwd } from "@/utiles/utiles";
import Cookies from "js-cookie";
import { ref, reactive, onMounted, computed } from "vue";
import {
  doLogin,
  getListCompanyInfo,
  updateLoginPw,
  getUserInfo,
} from "@/views/Login/api.js";

import {
  getCompanyOption
} from "@/views/VerificationData/api.js";
import { encrypt, decrypt } from "@/utiles/jsencrypt";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const ruleFormRef = ref<FormInstance>();
const Router = useRouter();
const companyList = ref<any>([]);
const formLabelAlign = reactive({
  userAccount: "",
  password: "",
  loginAccess: "PC",
  compCode: "",
});
const pwdDialogVisible = ref(false);
const pwdFormRef = ref();
const pwdForm = reactive({
  compCode: "",
  account: "",
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
});
let rememberMe = ref(false);
onMounted(() => {
  getCompanyInfo();
  getCookie();
  formLabelAlign.compCode = getUrlParams("code") || "";
  getUrlParams("code") &&
    sessionStorage.setItem("code", getUrlParams("code") || "");
});
// 检查Cookie中的登录信息

const getPasswordValidationMessage = computed(() => {
  if (!pwdForm.newPassword) return "";

  const errors = validatePassword(pwdForm.newPassword);
  if (errors.length === 0) {
    return "新密码格式正确";
  }
  return errors.join("\n");
});
const strengthLevel = computed(() => {
  const password = pwdForm.newPassword;
  if (!password) return 0;

  let score = 0;

  // 检查长度
  if (password.length >= 8) score++;

  // 检查字符种类
  if (/[A-Za-z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[@$!%*#?&]/.test(password)) score++;

  // 返回强度等级
  if (score <= 2) return 1; // 弱
  if (score == 3) return 2; // 中
  return 3; // 强
});

const validateUserCount = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请录入账号"));
  } else {
    if (formLabelAlign.userAccount !== "") {
      let reg = new RegExp(/^[0-9]{8,18}$/);
      if (value.length < 8 || value.length > 18) {
        callback("请录入8到18个字符的账号");
      } else if (!reg.test(formLabelAlign.userAccount)) {
        callback("请录入正确的账号");
      } else {
        callback();
      }
    }
  }
};
const validatePass = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请录入密码"));
  } else {
    if (formLabelAlign.password !== "") {
      let reg = new RegExp(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,18}$/);
      if (value.length < 8 || value.length > 18) {
        callback("请录入8到18个字符的密码");
      } else if (!reg.test(formLabelAlign.password)) {
        callback("请录入包含数字/字母字符的密码");
      } else {
        callback();
      }
    }
  }
};
const getCookie = () => {
  const userAccount = Cookies.get("userAccount");
  const password = Cookies.get("password");
  const rememberMe = Cookies.get("rememberMe");
  formLabelAlign.userAccount =
    userAccount === undefined
      ? formLabelAlign.userAccount
      : decrypt(userAccount);
  formLabelAlign.password =
    password === undefined ? formLabelAlign.password : decrypt(password);
  rememberMe = rememberMe === undefined ? false : decrypt(rememberMe);
};
const getUrlParams = (name: string, url?: string) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
const getCompanyInfo = () => {
  getListCompanyInfo().then((res: any) => {
    companyList.value = res;
  });
};
const rules = reactive<FormRules>({
  userAccount: [{ required: true, message: "请录入账号密码" }],
  password: [{ required: true, message: "请录入密码" }],
  compCode: [{ required: true, message: "请选择租户" }],
});
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      if (rememberMe.value) {
        Cookies.set("userAccount", encrypt(formLabelAlign.userAccount), {
          expires: 30,
        });
        Cookies.set("password", encrypt(formLabelAlign.password), {
          expires: 30,
        });
        Cookies.set("rememberMe", rememberMe.value, {
          expires: 30,
        });
      } else {
        Cookies.remove("userAccount");
        Cookies.remove("password");
        Cookies.remove("rememberMe");
      }
      doLogin(formLabelAlign)
        .then((res: any) => {
          ElMessage({
            type: "success",
            message: "登录成功",
          });
          const { sysUser, token } = res;
          console.log("sysUser", sysUser.menuList);
          store.dispatch('tabs/resetTabs')
          store.commit("SET_MENU", { menu: sysUser.menuList || [] });
          store.commit("SET_USERINFO", sysUser);
          localStorage.setItem(`token:${sysUser.id}`, token);
          // 获取租户配置信息
          getCompanyOptionFn(sysUser.compCode);
          store.dispatch("GetMenu");
          Router.push("/Home")
        })
        .catch((err: any) => {
          if (err.code === "6001") {
            setTimeout(() => {
              pwdForm.compCode = formLabelAlign.compCode;
              pwdForm.account = formLabelAlign.userAccount;
              pwdDialogVisible.value = true;
            }, 1000);
          }
          console.log(err);
        });
    } else {
      console.log("error submit!", fields);
    }
  });
};
const getCompanyOptionFn = (compCode: String) => {
  if (compCode) {
    getCompanyOption(compCode)
      .then((res: any) => {
        sessionStorage.setItem("companyInfoOptions", JSON.stringify(res));
      })
      .catch((error: any) => {
        console.error("Error fetching company options:", error);
      });
  } else {
    console.log("userInfo not found in sessionStorage");
  }
};
const validatePassword = (value) => {
  const hasLetter = /[A-Za-z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecialChar = /[@$!%*#?&]/.test(value);
  const isValidLength = value.length >= 8 && value.length <= 18;

  const errors = [];

  if (!isValidLength) {
    errors.push("密码长度需要在8-18位之间");
  }
  if (!hasLetter) {
    errors.push("需要包含至少一个字母");
  }
  if (!hasNumber) {
    errors.push("需要包含至少一个数字");
  }
  if (!hasSpecialChar) {
    errors.push("需要包含至少一个特殊字符(@$!%*#?&)");
  }

  return errors;
};
const pwdRules = reactive({
  compCode: [{ required: true, message: "请输入租户代码", trigger: "blur" }],
  account: [{ required: true, message: "请输入账号", trigger: "blur" }],
  oldPassword: [{ required: true, message: "请输入原密码", trigger: "blur" }],
  newPassword: [
    { required: true, message: "请输入新密码", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (!isMatchPwd(value)) {
          callback(new Error("请按照密码规则修改"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  confirmPassword: [
    { required: true, message: "请确认密码", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (value !== pwdForm.newPassword) {
          callback(new Error("两次输入的密码不一致"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
});
const handlePwdDialogClose = () => {
  pwdFormRef.value?.resetFields();
};

const handlePwdDialogCancel = () => {
  pwdDialogVisible.value = false;
  handlePwdDialogClose();
};

const handlePwdDialogConfirm = async () => {
  if (!pwdFormRef.value) return;

  await pwdFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        await updateLoginPw({
          compCode: pwdForm.compCode,
          account: pwdForm.account,
          oldPassword: pwdForm.oldPassword,
          newPassword: pwdForm.newPassword,
          confirmPassword: pwdForm.confirmPassword,
        });
        ElMessage({
          type: "success",
          message: "密码修改成功",
        });
        pwdDialogVisible.value = false;
        handlePwdDialogClose();
      } catch (error) { }
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require('../../assets/image/bg.png'),
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_image, {
                style: {"width":"100%","height":"100%"},
                src: require('../../assets/image/login.png')
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_form, {
                    "label-position": "top",
                    "label-width": "100px",
                    model: formLabelAlign,
                    rules: rules,
                    ref_key: "ruleFormRef",
                    ref: ruleFormRef
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_el_form_item, {
                        label: "租 户:",
                        prop: "compCode"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formLabelAlign.compCode,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formLabelAlign.compCode) = $event)),
                            placeholder: "租 户",
                            style: {"width":"100%"},
                            clearable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.compCode,
                                  label: item.compName,
                                  value: item.compCode
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, !getUrlParams('code')]
                      ]),
                      _createVNode(_component_el_form_item, {
                        label: "用户名:",
                        prop: "userAccount"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formLabelAlign.userAccount,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formLabelAlign.userAccount) = $event)),
                            maxlength: "18",
                            size: "large"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "密 码:",
                        prop: "password"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formLabelAlign.password,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formLabelAlign.password) = $event)),
                            maxlength: "18",
                            type: "password",
                            "show-password": "",
                            size: "large"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { class: "rememberMe" })
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "large",
                  class: "signIn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm(ruleFormRef.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("登 录")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: pwdDialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((pwdDialogVisible).value = $event)),
      title: "修改密码",
      width: "30%",
      "close-on-click-modal": false,
      onClose: handlePwdDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, { onClick: handlePwdDialogCancel }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handlePwdDialogConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确定 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "pwdFormRef",
          ref: pwdFormRef,
          model: pwdForm,
          rules: pwdRules,
          "label-width": "100px",
          class: "pwd-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "租户代码",
              prop: "compCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: pwdForm.compCode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((pwdForm.compCode) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "账号",
              prop: "account"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: pwdForm.account,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pwdForm.account) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "原密码",
              prop: "oldPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: pwdForm.oldPassword,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((pwdForm.oldPassword) = $event)),
                  type: "password",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "新密码",
              prop: "newPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: pwdForm.newPassword,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((pwdForm.newPassword) = $event)),
                  type: "password",
                  "show-password": ""
                }, null, 8, ["modelValue"]),
                (pwdForm.newPassword)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["pwd-bar", { 'pwd-weak': _unref(strengthLevel) >= 1 }])
                        }, null, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["pwd-bar", { 'pwd-medium': _unref(strengthLevel) >= 2 }])
                        }, null, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["pwd-bar", { 'pwd-strong': _unref(strengthLevel) >= 3 }])
                        }, null, 2)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "确认密码",
              prop: "confirmPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: pwdForm.confirmPassword,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((pwdForm.confirmPassword) = $event)),
                  type: "password",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _hoisted_10
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})